<template>
    <div class="history" v-show="!loading">
        <div class="history-item__wrapper" id="history-slide">
            <div class="history-item" v-for="(item, index) in historyItems" :key="index" :id="'history-item-' + index"
                :data-decade="item.decade">
                <div class="history-item__header">
                    <h2 class="history-item__year">{{ item.year }}</h2>
                    <div class="history-item__image" :style="`background-image: url(${item.image});`"></div>
                </div>
                <div class="history-item__content">
                    <div class="history-item__title" v-html="item.title"></div>
                    <div v-html="item.introText"></div>
                </div>
            </div>
        </div>
        <div class="history-footer">
            <div class="history-legend">
                <div class="history-legend__arrow" @click="chevronClick('back')"
                    :style="`opacity: ${leftDisabled ? 0.5 : 1}`">
                    <i class="icon-chevron-left"></i>
                </div>
                <ul class="history-legend__wrapper" ref="legendScroller">
                    <li class="history-legend__item" :class="selectedItem == legendIndex ? 'active' : ''"
                        v-for="(item, legendIndex) in decades" :key="'legend-' + legendIndex" :id="'legend-' + legendIndex"
                        :data-item="item" @click="selectHistoryItem(this, item.index)">
                        {{ item.decade }}
                    </li>
                </ul>
                <div class="history-legend__arrow" @click="chevronClick('forward')"
                    :style="`opacity: ${rightDisabled ? 0.5 : 1}`">
                    <i class="icon-chevron-right"></i>
                </div>
            </div>
            <div class="history-overview">
                <a v-if="overviewButton" :href="overviewButton.Url" class="button">{{
                    overviewButton.Name
                }}</a>
            </div>
        </div>
    </div>
    <div class="history-overview--mobile">
        <a v-if="overviewButton" :href="overviewButton.Url" class="button">{{
            overviewButton.Name
        }}</a>
    </div>
</template>

<script>
import HistoryService from "../../services/history";

export default {
    props: ["title", "category", "overviewButton"],
    data() {
        return {
            loading: true,
            selectedItem: 0,
            historyItems: [],
            decades: [],
            values: [],
            elements: [],
            scrollListener: null,
        };
    },
    computed: {
        leftDisabled: function () {
            if (this.selectedItem < 1) {
                return true;
            } else {
                return false;
            }
        },
        rightDisabled: function () {
            if (this.selectedItem < this.historyItems.length - 1) {
                return false;
            } else {
                return true;
            }
        },
    },
    mounted() {
        this.getHistory();
    },
    methods: {
        chevronClick: function (direction) {
            let slider = document.getElementById("history-slide");

            let self = this;
            self.values = [];
            self.elements = [];

            document.querySelectorAll(".history-item").forEach((el, index) => {
                self.values.push(el.offsetLeft);
                self.elements.push({
                    key: index,
                    value: el.offsetLeft,
                    decade: el.dataset.decade,
                    element: el,
                });
            });

            let goal = slider.scrollLeft;

            let closest = self.values.reduce(function (prev, curr) {
                return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
            });

            let next = self.elements.filter((element) => {
                return element.value === closest;
            });

            if (next && next.length > 0 && next[0].element.nextElementSibling && direction === "forward") {
                slider.scrollTo({
                    left: window.innerWidth > 1024 ? next[0].element.nextElementSibling.offsetLeft - 60 : next[0].element.nextElementSibling.offsetLeft - 16,
                    behavior: 'smooth'
                })
            }

            if (next && next.length > 0 && next[0].element.previousElementSibling && direction === "back") {
                slider.scrollTo({
                    left: window.innerWidth > 1024 ? next[0].element.previousElementSibling.offsetLeft - 60 : next[0].element.previousElementSibling.offsetLeft - 16,
                    behavior: 'smooth'
                })
            }
        },
        getHistory: async function () {
            try {
                if (this.category && this.category != "") {
                    const historyResponse = await HistoryService.historyCategory(
                        this.category
                    );
                    this.historyItems = historyResponse.historyItems.sort(function (
                        a,
                        b
                    ) {
                        return a.year.replace(/\D/g, '') - b.year.replace(/\D/g, '');
                    });
                } else {
                    const historyResponse = await HistoryService.history();
                    this.historyItems = historyResponse.historyItems.sort(function (
                        a,
                        b
                    ) {
                        return a.year.replace(/\D/g, '') - b.year.replace(/\D/g, '');
                    });
                }

                this.historyItems.forEach((item, index) => {
                    let check =
                        this.decades.length > 0 &&
                        this.decades.filter((decade) => {
                            return decade.decade === item.decade;
                        });
                    if (!check || check.length === 0) {
                        this.decades.push({ decade: item.decade, index: index });
                    }
                });

                this.loading = false;
                this.setupScrollListener();
                this.setupScrollPopListener();

                setTimeout(() => {
                    document.querySelector(".history-item").classList.add("history-item--active")
                }, 500);
            } catch (error) {
                console.log(error);
            }
        },
        selectHistoryItem: function (e, index) {
            // this.selectedItem = index;
            document.getElementById("history-slide").scrollTo({
                left:
                    window.innerWidth > 1024
                        ? (480 + 120) * index
                        : (document.querySelector(".history-item").clientWidth + 45) *
                        index,
                behavior: "smooth",
            });
            // e.target.scrollIntoView()
        },
        setupScrollListener: function () {
            let slider = document.getElementById("history-slide");
            let self = this;

            slider.addEventListener("scroll", function () {
                self.values = [];
                self.elements = [];

                document.querySelectorAll(".history-item").forEach((el, index) => {
                    self.values.push(el.offsetLeft - (window.innerWidth > 1024 ? 120 : 45));
                    self.elements.push({
                        key: index,
                        value: el.offsetLeft - (window.innerWidth > 1024 ? 120 : 45),
                        decade: el.dataset.decade,
                    });
                });

                let goal = slider.scrollLeft;

                let closest = self.values.reduce(function (prev, curr) {
                    return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
                });

                let active = self.elements.filter((element) => {
                    return element.value === closest;
                });

                let selected = self.decades.findIndex((decade) => {
                    return decade.decade === active[0].decade;
                });

                self.selectedItem = selected;
                document.querySelector(".history-legend__wrapper").scrollTo({
                    left: 90 * selected,
                    behavior: "smooth",
                });

            });
        },
        setupScrollPopListener: function () {
            let slider = document.getElementById("history-slide");
            let self = this;

            slider.addEventListener("scroll", function () {
                self.values = [];
                self.elements = [];

                document.querySelectorAll(".history-item").forEach((el, index) => {
                    self.values.push(el.offsetLeft - (window.innerWidth > 1024 ? 120 : 45));
                    self.elements.push({
                        element: el,
                        value: el.offsetLeft - (window.innerWidth > 1024 ? 120 : 45)
                    });
                });

                let goal = slider.scrollLeft;

                let closest = self.values.reduce(function (prev, curr) {
                    return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
                });

                let active = self.elements.filter((element) => {
                    return element.value === closest;
                });

                document.querySelectorAll(".history-item--active").forEach((el) => {
                    el.classList.remove("history-item--active")
                });

                active[0].element.classList.add("history-item--active")
            });
        },
    },
};
</script>

